import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdatePublicationCommentListQuery } from "@/queries/query-publication-comment";

type EditCommentMessageArgs = {
  commentId: string;
  messageIndex: number;
  body: string;
};

export const useEditCommentMessage = (publicationId: string, onSuccess?: () => void) => {
  const update = useUpdatePublicationCommentListQuery(publicationId);

  return useMutationWithErrorHandler(
    async ({ commentId, messageIndex, body }: EditCommentMessageArgs) => {
      const comment = await getRanaApiV1().PublicationCommentsApi.commentUpdateMessage({
        publicationId,
        commentId,
        messageIndex,
        messageUpdate: { body },
      });

      await update(comment.id, comment);
    },
    {
      onSuccess,
    }
  );
};
